import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSession } from "../../hooks/useSession";
import {
  authOptionsFooterDivider,
  callAPIInterface,
  handleAfterLoginProcess,
  logOut,
} from "../constants";
import { Box } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import Text from "../text/Text";
import { create, loginConsentMessage, signOut } from "../messages";
import Button from "../button/Button";
import CommonHeader from "../CommonHeader";
import CommonAuthHeader from "../options/CommonAuthHeader";

const CreateWalletConsent = ({ isFromOptions = false }) => {
  const navigate = useNavigate();
  const { session, error } = useSession();
  const [disabled, setDisabled] = useState(false);

  if (error) {
    navigate("/", { replace: true });
    return null;
  }
  const user = session?.user;
  const handleCreateAccount = async () => {
    try {
      setDisabled(true);

      const data = {
        name: "Wallet Account",
      };

      const response = await callAPIInterface(
        "POST",
        "/account",
        JSON.stringify(data)
      );

      if (response) {
        handleAfterLoginProcess(navigate);
      }
    } catch (error) {
    } finally {
      setDisabled(false);
    }
  };

  const handleLogout = async () => {
    setDisabled(true);
    try {
      await logOut();
    } catch (error) {
    } finally {
      setDisabled(false);
    }
  };

  return (
    <>
      <CommonHeader icon="backArrow" navigation="/" />
      <CommonAuthHeader showSpeedLogo={false}>
        <Box
          display="flex"
          flexDirection="column"
          justifyContent="space-between"
          gap={40}
          height="100%"
        >
          <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            marginTop="20px"
          >
            <ErrorOutlineIcon
              sx={{ color: "#D88A2C", height: "54px", width: "54px" }}
            />
            <Text
              className="grey-text"
              size={14}
              font="regular"
              component="span"
              sx={{ textAlign: "center" }}
            >
              {loginConsentMessage[0]} <br />
              <Text
                className="default-text"
                size={14}
                font="semibold"
                component="span"
              >
                {user?.email}
              </Text>
              <br /> {loginConsentMessage[1]}
            </Text>
          </Box>

          <Box>
            {isFromOptions && authOptionsFooterDivider}
            <Box
              className={!isFromOptions ? "footer" : ""}
              gap="9px"
              left={0}
              sx={isFromOptions && { display: "flex" }}
            >
              <Button
                sx={{
                  width: "50%",
                  // ...(!isFromOptions && { m: "14px 0px 14px 20px" }),
                }}
                variant="outlined"
                label={signOut}
                onClick={handleLogout}
                disabled={disabled}
                {...(!isFromOptions && { textClass: "font-14" })}
              />
              <Button
                sx={{
                  width: "50%",
                  ...(!isFromOptions && { m: "14px 20px 14px 0px" }),
                }}
                variant="contained"
                label={create}
                onClick={handleCreateAccount}
                disabled={disabled}
                {...(!isFromOptions && { textClass: "font-14" })}
              />
            </Box>
          </Box>
        </Box>
      </CommonAuthHeader>
    </>
  );
};

export default CreateWalletConsent;
